import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { ITAFBookS1 } from './taf-book-s1-list';


import { TAFBookS1Service } from './taf-book-s1.service';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-s1/taf-book-s1.component.html',
    template: require('./taf-book-s1.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
})

export class TAFBookS1Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK S1';
    errorMessage: string;
    tafBookS1Arr: ITAFBookS1;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookS1Service: TAFBookS1Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookS1Service.getTAFBookS1()
         .subscribe(
                tafBookS1Arr => this.tafBookS1Arr = tafBookS1Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s1/taf-book-s1.component.ts
 **/